import { Button } from "@heroui/react";
import { NavLink } from "react-router";
import { useLogout } from "@/src/auth/hooks/use-logout";
import { ADMIN_NAV_ITEMS, type AdminNavItem } from "@/src/common/constants/admin-navigation";
import { env } from "@/src/common/constants/env";
import { getSessionUser } from "@/src/common/redux/session-slice";
import { useAppSelector } from "@/src/common/redux/store";

const navLinkClass = (isActive: boolean): string =>
	isActive
		? "flex items-center rounded-xl bg-accent-soft px-3 py-2.5 text-sm font-semibold text-accent-lav"
		: "flex items-center rounded-xl px-3 py-2.5 text-sm font-medium text-muted hover:bg-glass hover:text-foreground";

const AdminSidebarNavLink: React.FC<{ item: AdminNavItem }> = ({ item }) => (
	<NavLink to={item.to} end={item.to === "/"} className={({ isActive }) => navLinkClass(isActive)}>
		{item.label}
	</NavLink>
);

const initialOf = (value: string): string => value.trim().charAt(0).toUpperCase() || "?";

const AdminSidebar: React.FC = () => {
	const user = useAppSelector(getSessionUser);
	const logout = useLogout();

	return (
		<aside className="sticky top-0 flex h-dvh w-64 shrink-0 flex-col gap-6 border-r border-border bg-surface px-3 py-5">
			<span className="px-3 text-xl font-bold tracking-tight text-foreground">{`${env.APP_NAME} Admin`}</span>

			<nav className="flex flex-1 flex-col gap-1">
				{ADMIN_NAV_ITEMS.map((item) => (
					<AdminSidebarNavLink key={item.to} item={item} />
				))}
			</nav>

			<div className="flex flex-col gap-2 border-t border-border pt-4">
				{user ? (
					<div className="flex items-center gap-3 rounded-xl p-3">
						<span className="flex size-9 items-center justify-center rounded-full bg-accent-soft text-sm font-semibold text-accent-lav">
							{initialOf(user.displayName)}
						</span>
						<span className="flex min-w-0 flex-col">
							<span className="truncate text-sm font-semibold text-foreground">{user.displayName}</span>
							<span className="truncate text-xs text-muted">{user.email}</span>
						</span>
					</div>
				) : null}

				<Button variant="ghost" onPress={() => void logout()} className="justify-start px-3 text-sm font-medium text-danger">
					Se déconnecter
				</Button>
			</div>
		</aside>
	);
};

export default AdminSidebar;
